<template>
  <v-application>
    <v-row class="mx-1 mt-n7 mb-2 mb-sm-10">
      <v-col class="px-2">
        <v-card
          class="px-6 pt-4 py-2"
          width="61.5%"
          style="position: fixed; z-index: 1100"
          elevation="8"
        >
          <v-row>
            <v-flex class="px-1" md6>
              <v-autocomplete
                v-model="item"
                :items="items_list"
                item-text="search_text"
                v-bind:label="'Add item'"
                @change="onChange"
                return-object
                v-on:update:search-input="getItems"
              >
                <template #selection>
                  <p class="ma-0 pa-0">{{ item ? item.product_name : "" }}</p>
                </template>
                <template #item="data">
                  <template>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        data.item.product_name
                      }}</v-list-item-title>
                      <v-list-item-subtitle
                        >SKU {{ data.item.sku }}</v-list-item-subtitle
                      >
                      <v-list-item-subtitle
                        v-if="data.item.barcode && data.item.barcode.length > 0"
                      >
                        Barcode
                        <span
                          v-for="(barcode, ind) in data.item.barcode"
                          :key="ind"
                          >{{ barcode + ", " }}</span
                        >
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex class="px-1" md3>
              <v-text-field
                v-model="quality"
                label="Quantity"
                reverse
                @focus="$event.target.select()"
              />
            </v-flex>
            <v-flex class="px-1 pt-3" md3>
              <v-btn
                color="primary"
                text
                block
                v-on:click="add_item"
                :disabled="add_disabled"
                >add to count</v-btn
              >
            </v-flex>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-layout row class="ma-2 mt-16">
      <v-flex md9 class="px-1">
        <v-card class="mb-3">
          <v-card-text>
            <!-- <v-row>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-row> -->
          </v-card-text>
          <v-divider />
          <v-data-table
            v-bind:headers="headers"
            hide-default-footer
            v-bind:items="items"
            :items-per-page="10000"
          >
            <template #[`item.product_name`]="{ item }">
              <v-list-item-content>
                <p style="max-width: 400px">
                  {{ item.product_name }}
                </p>
                <v-list-item-subtitle>SKU {{ item.sku }}</v-list-item-subtitle>
                <v-list-item-subtitle
                  v-if="item.barcode && item.barcode.length > 0"
                >
                  Barcode
                  <span v-for="(barcode, ind) in item.barcode" :key="ind">{{
                    barcode + ", "
                  }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
            <template #[`item.value`]="{ item }">
              <v-text-field
                v-model="item.counted"
                reverse
                v-on:blur="change(item)"
                :id="item._id"
                @focus="$event.target.select()"
              />
            </template>
            <template #[`item.cost_difference`]="{ item }">
              {{
                item.cost_difference
                  ? item.cost_currency == "usd"
                    ? item.cost_difference.toLocaleString() + " $"
                    : Math.floor(item.cost_difference).toLocaleString()
                  : item.cost_difference
              }}
            </template>
          </v-data-table>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn text color="primary" v-on:click="save">save</v-btn>
            <v-btn
              text
              color="primary"
              v-on:click="complete"
              :disabled="saveDisabled"
              >complete</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex md3 class="px-1">
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title>History</v-toolbar-title>
          </v-toolbar>
          <v-list>
            <v-list-item v-for="(h, index) in history" v-bind:key="index">
              <v-list-item-content>
                <v-list-item-title
                  >{{ h.value }} {{ h.product_name }}</v-list-item-title
                >
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon v-on:click="remove_history(h._id)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-application>
</template>
<script>
export default {
  name: "InventoryCountsComplete",
  data: () => ({
    headers: [
      { text: "Item", value: "product_name" },
      {
        text: "Expected stock",
        value: "exp_in_stock",
        align: "right",
        width: 200,
      },
      { text: "Counted", value: "value", align: "right", width: 100 },
      { text: "Difference", value: "difference", align: "right", width: 100 },
      {
        text: "Cost difference",
        value: "cost_difference",
        align: "right",
        width: 100,
      },
    ],
    items_list: [],
    items: [],
    item: null,
    item_find: false,
    search: "",
    quality: 1,
    params: {
      items: [],
    },
    count_id: null,
    history: [],
    counts: {
      items: [],
    },
    search_text: "123",
    containerMargin: 0,
    itemsMap: {},
    add_disabled: false,
  }),
  mounted() {
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    this.update();
  },
  computed: {
    saveDisabled() {
      return this.history.length == 0;
    },
  },
  methods: {
    onChange() {
      if (document.getElementById(`${this.item?.product_id}`)) {
        document.getElementById(`${this.item?.product_id}`).focus();
      }
      for (const it of this.items) {
        if (it.product_id === this.item?.product_id) {
          this.add_disabled = true;
          break;
        } else {
          this.add_disabled = false;
        }
      }
    },

    async complete() {
      await this.$communicator("complete_counts", {
        arguments: [this.count_id],
      });
      this.$toast.success("Success", { timeout: 2000 });
      this.save();
    },
    save() {
      this.$router.push({
        path: "/inventory/counts/view",
        query: this.$route.query,
      });
    },
    async add_item() {
      if (this.item && this.item.product_id) {
        let item = {
          product_id: this.item.product_id,
          counted: this.quality,
          count_id: this.count_id,
          product_name: this.item.product_name,
          in_stock: this.item.in_stock,
        };
        this.items.push(this.$copy(item));
        const zb = [...this.items];
        await this.$communicator("update_counts", {
          arguments: [this.$route.query["id"]],
          params: {
            service: this.counts.service,
            type: "partial",
            items: zb.map((i) => {
              i.counted = 0;
              return i;
            }),
          },
        });

        this.change(item, true);
      }
      this.item = null;
    },
    async remove_history(id) {
      await this.$communicator("delete_counts_history", {
        arguments: [id],
      });
      this.update(false);
    },
    async change(item, is = true) {
      var params = {
        count_id: this.count_id,
        product_id: item.product_id,
        value: item.counted,
      };
      if (is) {
        params.input_changed = true;
      }
      await this.$communicator("create_counts_history", {
        params: params,
      });
      this.update(false);
    },
    async update() {
      const counts = this.$communicator.then(
        this,
        await this.$communicator("counts_by_id", {
          arguments: [this.$route.query["id"]],
        })
      );

      this.count_id = counts?._id;
      this.counts = counts;

      const items_list = [];
      for (const itm of this.counts.items) {
        // itemsMap[itm._id] = itm
        items_list.push(itm);
      }
      this.items = items_list;
      this.countItemsRefresh();
      this.getItems("");
      const history = this.$communicator.then(
        this,
        await this.$communicator("counts_history", {
          arguments: [counts._id],
        })
      );
      if (history) {
        this.history = history;
      }
    },
    async countItemsRefresh() {
      const ids = [];
      if (!(this.counts.items instanceof Array)) {
        this.counts.items = [];
      }
      for (const itm of this.counts.items) {
        ids.push(itm.product_id);
      }

      const items = this.$communicator.then(
        this,
        await this.$communicator("inv_items_refresh", {
          params: {
            service: this.counts.service,
            indexes: ids,
          },
        })
      );

      if (items) {
        const inStockMap = {};
        for (const itm of items) {
          inStockMap[itm._id] = itm.in_stock;
        }
        for (const ind in this.counts.items) {
          if (inStockMap[this.counts.items[ind].product_id]) {
            this.counts.items[ind].in_stock =
              inStockMap[this.counts.items[ind].product_id];
          } else {
            this.counts.items[ind].in_stock = 0;
          }
        }
      }
    },
    async getItems(search = "") {
      if (typeof search != typeof "invan") {
        search = "";
      }
      if (this.search_text == search || !this.counts.service) {
        return;
      }
      this.search_text = search;
      const items = this.$communicator.then(
        this,
        await this.$communicator("get_inv_count_items", {
          arguments: [50, 1],
          params: {
            service: this.counts.service,
            categories: [],
            suppliers: [],
            search: search,
          },
        })
      );

      if (items) {
        var items_list = [];
        for (const index in items) {
          let search_text = items[index].name + items[index].sku;
          if (
            items[index].barcode &&
            typeof items[index].barcode == typeof []
          ) {
            for (const b of items[index].barcode) {
              search_text += b;
            }
          }
          items_list.push({
            product_id: items[index]._id,
            product_name: items[index].name,
            search_text: search_text,
            quality: null,
            sku: items[index].sku,
            barcode: items[index].barcode,
            in_stock: items[index].in_stock,
          });
        }
        this.items_list = items_list;
      }
    },
  },
};
</script>
